import Information from './Information'
import Setting from './Setting'

const EGPlatform = {
    Information,
    Setting,
}

export default EGPlatform
